export default "__VITE_ASSET__371179ce__"